import React, {useState} from 'react';
import {useSelector} from 'react-redux';

import {appConfig} from '@ibibo/hotels-config';
import {reviewPagePricingSelector} from '@ibibo/hotels-review-reducer';

import * as S from './PricingBlock.styles';

import PriceBlockLoader from '../../Loadingpage/ReviewPageLoaders/PriceBlockLoader/PriceBlockLoader';

const PricingBlock: React.FC<{loading: boolean; earlycheckin: boolean}> = ({
  loading,
  earlycheckin,
}) => {
  const {
    reviewPagePricing = [],
    finalAmount,
    internationalCurrency,
    internationalTotalAmount,
  } = useSelector(reviewPagePricingSelector);

  const [open, setOpen] = useState(true);

  return (
    <S.PricingBlockWrapDiv>
      {(loading && <PriceBlockLoader />) || (
        <S.PricingBlockInnerWrapDiv>
          <S.PricingTxtWrapDiv>
            <S.PricingTxtSpan>PRICE</S.PricingTxtSpan>
            <S.CircularDiv onClick={() => setOpen(state => !state)}>
              <S.ArrowDownNewWrap transformstyle={(open && 'rotate(180deg)') || 'rotate(0deg)'} />
            </S.CircularDiv>
          </S.PricingTxtWrapDiv>

          <S.RoomChargesOuterWrapDiv display={!open && 'none'}>
            <S.RoomChargesWrapDiv>
              {reviewPagePricing
                .filter(
                  ({id}) =>
                    ((earlycheckin && true) || id !== appConfig.reviewPagePricingAddOnListEarlyCheckInID)
                )
                .map(
                  ({
                    v: amount,
                    v_wogc: amountWithoutGC,
                    k: text,
                    c: currency,
                    id,
                    fw,
                    fs,
                    cc,
                    s: sign,
                  }) => {
                    if (amount <= 0) {
                      return null;
                    }
                    return (
                      <S.ConviFeeWrapDiv key={id} fw={fw} fs={fs} color={cc}>
                        <S.PricingNewWrapDiv>
                          <S.ConvifeeTxtSpan>{text}</S.ConvifeeTxtSpan>
                          <S.BreakUpPriceWrapSpan>{`${sign}${currency}${parseInt(amount).toLocaleString('en-IN')}`}
                          </S.BreakUpPriceWrapSpan>
                        </S.PricingNewWrapDiv>
                      </S.ConviFeeWrapDiv>
                    );
                  },
                )}
            </S.RoomChargesWrapDiv>
          </S.RoomChargesOuterWrapDiv>

          {/* (!!internationalCurrency && !!internationalTotalAmount && (
            <>
              <S.RoomChargesTotalOuterWrapDiv>
                <S.RoomTotalPriceWrap>
                  <S.RoomTotalPriceInnerWrap>
                    <S.DiscountTxtSpan>Total Payable in your currency</S.DiscountTxtSpan>
                    <S.PricingInnerWrapDiv>
                      <S.AmountTxtSpan>
                        {appConfig.rupeeString}
                        {finalAmount}
                      </S.AmountTxtSpan>
                    </S.PricingInnerWrapDiv>
                  </S.RoomTotalPriceInnerWrap>
                  <S.RoomTotalPriceInnerWrap>
                    <S.DiscountTxtSpan>You Will Pay</S.DiscountTxtSpan>
                    <S.PricingInnerWrapDiv>
                      <S.AmountTxtSpan>
                        {`${internationalCurrency} ${Math.round(internationalTotalAmount * 100) /
                          100}`}
                      </S.AmountTxtSpan>
                    </S.PricingInnerWrapDiv>
                  </S.RoomTotalPriceInnerWrap>
                </S.RoomTotalPriceWrap>
              </S.RoomChargesTotalOuterWrapDiv>
            </>
          )) || (
            <S.RoomChargesTotalOuterWrapDiv>
              <S.RoomTotalPriceWrap>
                <S.RoomTotalPriceInnerWrap>
                  <S.TotalAmountInfoTxtSpan>Total Payable</S.TotalAmountInfoTxtSpan>
                  <S.PricingInnerWrapDiv>
                    <S.TotalAmountTxtSpan>
                      {appConfig.rupeeString}
                      {finalAmount}
                    </S.TotalAmountTxtSpan>
                  </S.PricingInnerWrapDiv>
                </S.RoomTotalPriceInnerWrap>
              </S.RoomTotalPriceWrap>
            </S.RoomChargesTotalOuterWrapDiv>
          ) */}
          <S.RoomChargesTotalOuterWrapDiv>
            <S.RoomTotalPriceWrap>
              <S.RoomTotalPriceInnerWrap>
                <S.TotalAmountInfoTxtSpan>Total Payable</S.TotalAmountInfoTxtSpan>
                <S.PricingInnerWrapDiv>
                  <S.TotalAmountTxtSpan>
                    {appConfig.rupeeString}
                    {finalAmount.toLocaleString('en-IN')}
                  </S.TotalAmountTxtSpan>
                </S.PricingInnerWrapDiv>
              </S.RoomTotalPriceInnerWrap>
            </S.RoomTotalPriceWrap>
            </S.RoomChargesTotalOuterWrapDiv>
        </S.PricingBlockInnerWrapDiv>
      )}
    </S.PricingBlockWrapDiv>
  );
};

export default PricingBlock;
